import React, { useEffect, useState } from "react";
import useHttp from "../../hooks/use-http";

const WarehouseDashboard = () => {
  const [data, setData] = useState();
  const [dueData, setDueData] = useState([]);
  const [purchaseData, setPurchaseData] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [showAllDue, setShowAllDue] = useState(false);
  const [showAllPurchase, setShowAllPurchase] = useState(false);
  const [showAllStock, setShowAllStock] = useState(false);

  const { sendRequest: getData } = useHttp();
  useEffect(() => {
    getData(
      {
        url: `/api/warehouseWebDashBoardSummary/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setData(data);
      }
    );
  }, [getData]);

  const { sendRequest: overDueData } = useHttp();
  useEffect(() => {
    overDueData(
      {
        url: `/api/warehouseOverDuePOList/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (data) => {
        setDueData(data.output);
      }
    );
  }, [overDueData]);

  const { sendRequest: getTodaysPurchaseProduct } = useHttp();
  useEffect(() => {
    getTodaysPurchaseProduct(
      {
        url: `/api/warehousetodaysPurchaseProductList/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (data) => {
        setPurchaseData(data.output);
      }
    );
  }, [getTodaysPurchaseProduct]);

  const { sendRequest: getwarehouseExpiredStockList } = useHttp();
  useEffect(() => {
    getwarehouseExpiredStockList(
      {
        url: `/api/warehouseExpiredStockList/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (data) => {
        setStockData(data.output);
      }
    );
  }, [getwarehouseExpiredStockList]);

  const handleShowAllDue = () => setShowAllDue(true);
  const handleShowAllPurchase = () => setShowAllPurchase(true);
  const handleShowAllStock = () => setShowAllStock(true);

  return (
    <>
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* <div className="col-12 col-sm-6 col-md-4">
                <div className="info-box bg-warning">
                  <div className="info-box-content">
                    <label className="info-box-text">No of Vendor</label>
                    <div className="row text-center">
                      <div className="col-12 col-sm-12 col-md-12">
                        <label> {data && data.noOfVendor}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-lg-4 col-6">
                <div className="small-box bg-warning">
                  <div className="inner">
                    <h3>{(data && data.noOfVendor) || 0}</h3>

                    <p>Number Of Vendor</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-person-add"></i>
                  </div>
                </div>
              </div>

              {/* <div className="col-12 col-sm-6 col-md-4">
                <div className="info-box mb-3 bg-success">
                  <div className="info-box-content">
                    <label className="info-box-text">No Of Products</label>
                    <div className="row text-center">
                      <div className="col-12 col-sm-12 col-md-12">
                        <label>{data && data.noOfProduct}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="col-lg-4 col-6">
                <div className="small-box bg-info">
                  <div className="inner">
                    <h3>{(data && data.noOfProduct) || 0}</h3>

                    <p>No Of Products</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-bag"></i>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-6">
                <div className="small-box bg-success">
                  <div className="inner">
                    <h3>{(data && data.totalValue.toFixed(2) )|| 0}</h3>

                    <p>Inventory Value</p>
                  </div>
                  <div className="icon">
                    <i className="ion ion-stats-bars"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-6 col-12 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <label className="info-box-text">
                      Overdue Purchase Order
                    </label>
                    <div className="row">
                      <table className="table table-bordered text-center ">
                        <thead className="bg-success">
                          <tr>
                            <th>PO Number</th>
                            <th>Vendor Name</th>
                            <th>OverDue (Day)</th>
                          </tr>
                        </thead>
                        <tbody className="bg-info">
                          {dueData &&
                            dueData
                              .slice(0, showAllDue ? dueData.length : 5)
                              .map((x, i) => (
                                <tr key={i}>
                                  <td>{x.docNo}</td>
                                  <td>{x.vendorName}</td>
                                  <td>{x.overDueDays}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                      {!showAllDue && dueData.length > 5 && (
                        <a href="#" onClick={handleShowAllDue}>
                          more...
                        </a>
                      )}
                      {showAllDue && dueData.length > 5 && (
                        <a href="#" onClick={() => setShowAllDue(false)}>
                          less...
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <label className="info-box-text">
                      Today's Product Purchase
                    </label>
                    <div className="row">
                      <table className="table table-bordered text-center bg-secondary">
                        <thead>
                          <tr>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody className="bg-cyan">
                          {purchaseData &&
                            purchaseData
                              .slice(
                                0,
                                showAllPurchase ? purchaseData.length : 5
                              )
                              .map((x, i) => (
                                <tr key={i}>
                                  <td>{x.productName}</td>
                                  <td>
                                    {x.goodsReceiptQuantity} (
                                    {x.unitAbbreviation})
                                  </td>
                                  <td>{x.stockAmount}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>

                      {!showAllPurchase && purchaseData.length > 5 && (
                        <div className="text-right">
                          {" "}
                          <a href="#" onClick={handleShowAllPurchase}>
                            more...
                          </a>{" "}
                        </div>
                      )}
                      {showAllPurchase && purchaseData.length > 5 && (
                        <a href="#" onClick={() => setShowAllPurchase(false)}>
                          less...
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row text-center">
              <div className="col-md-6 col-12 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <label className="info-box-text">
                      Inventory Minimum Notifier
                    </label>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead className="bg-warning">
                          <tr>
                            <th>Product Name</th>
                            <th>Quantity</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody className="bg-info">
                          {stockData &&
                            stockData
                              .slice(0, showAllStock ? stockData.length : 5)
                              .map((x, i) => (
                                <tr key={i}>
                                  <td>{x.productName}</td>
                                  <td>
                                    {x.productQuantity} ({x.unitAbbreviation})
                                  </td>
                                  <td>{x.productAmount}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                      {!showAllStock && stockData.length > 5 && (
                        <a href="#" onClick={handleShowAllStock}>
                          more...
                        </a>
                      )}
                      {showAllStock && stockData.length > 5 && (
                        <a href="#" onClick={() => setShowAllStock(false)}>
                          less...
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12 col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <label className="info-box-text"></label>
                    <div className="row"></div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WarehouseDashboard;
